import { getDataForBadgeTemplateImageGeneration } from '@/ui/features/badging/badging-configuration/getDataForBadgeTemplateImageGeneration';
import { alertUiAdminPages } from '@juvare/alert-ui/ui/features/classifiers-admin-pages';
import { useBadgeTemplatesClassifierPages, useRevokedBadgeReasonsClassifierPages } from '@juvare/badging/ui/features/badge-admin-pages';
import { requireAnySystemPermission } from '@juvare/contact-management/backend/features/permissions/shared';
import { getContactManagementAdminPages } from '@juvare/contact-management/ui/features/classifiers-admin-pages';
import { contactUsAdminPages } from '@juvare/contact-management/ui/features/contact-us/components/ContactUsAdminPages';
import { getCredentialingAdminPages } from '@juvare/credentialing/ui/features/classifiers-admin-pages';
import { getMissionAdminPages } from '@juvare/missions/ui/features/mission-admin-pages';
import { ConfigurationPageDef } from '@juvare/platform-sdk-react/ui/features/classifiers';
import { useDefaultClassifierAdminPages } from '@juvare/platform-sdk-react/ui/features/default-classifiers';
import { getUserState } from '@juvare/platform-sdk-react/ui/stores';
import { useSelector } from 'react-redux';

export function useConfigurationPages(): ConfigurationPageDef[] {
    const userState = useSelector(getUserState);

    const badgeTemplatesClassifierPages = useBadgeTemplatesClassifierPages(getDataForBadgeTemplateImageGeneration);
    const revokedBadgeReasonsClassifierPages = useRevokedBadgeReasonsClassifierPages();

    const configurationPages = [
        ...getContactManagementAdminPages(userState),
        ...getCredentialingAdminPages(userState),
        ...getMissionAdminPages(userState),
        ...badgeTemplatesClassifierPages,
        ...revokedBadgeReasonsClassifierPages,
    ];
    const defaultConfigurationPages = useDefaultClassifierAdminPages();
    if (requireAnySystemPermission(userState, 'manage-all-classifiers')) {
        configurationPages.push(...alertUiAdminPages, ...contactUsAdminPages, ...defaultConfigurationPages);
    }
    configurationPages.sort((a, b) => (a.label > b.label ? 1 : -1));
    return configurationPages;
}
